import { Auth0Client } from '@auth0/auth0-spa-js';

const LOGIN_ERROR_QUERY = { login_error: 'universal_login_failed' };

// 失敗したときに戻るログイン画面（signin__error に失敗文言が出る）
export const UNIVERSAL_LOGIN_FAILED_ROUTE = { path: '/sign_in', query: LOGIN_ERROR_QUERY };

// CONFIG は /config.js が定義する。テスト環境では未定義のため typeof で確かめる
// eslint-disable-next-line no-undef
const readConfig = () => (typeof CONFIG === 'undefined' ? {} : CONFIG);

// config.js（client/config/stages.json から生成）に Auth0 の設定が載っているステージだけ有効
export const isUniversalLoginEnabled = () => !!readConfig().AUTH0_DOMAIN;

// 成功は code、拒否・失敗は error が、state と一緒に付いて戻る
export const isUniversalLoginCallback = (url) => {
  const params = new URL(url).searchParams;
  return params.has('state') && (params.has('code') || params.has('error'));
};

export const isUniversalLoginFailed = (query) => query.login_error === LOGIN_ERROR_QUERY.login_error;

const buildClient = () => {
  const config = readConfig();
  // audience と scope は生成時に固定する。呼び出しごとに変えるとトークンのキャッシュに当たらない
  return new Auth0Client({
    domain: config.AUTH0_DOMAIN,
    clientId: config.AUTH0_CLIENT_ID,
    authorizationParams: {
      audience: config.AUTH0_AUDIENCE,
      scope: 'openid email',
      redirect_uri: window.location.origin,
    },
  });
};

// redirectTo（ログイン前に開こうとしたページ）は Auth0 を往復する間 appState に載せて持ち回る
export const redirectToUniversalLogin = ({ redirectTo } = {}) => (
  buildClient().loginWithRedirect({ appState: { redirectTo } })
);

// 認可コードをアクセストークンに交換する。handleRedirectCallback はトークンを返さないため、同じクライアントのキャッシュから取り出す
const exchangeToken = async (url) => {
  const client = buildClient();
  const { appState } = await client.handleRedirectCallback(url);
  const token = await client.getTokenSilently({ cacheMode: 'cache-only' });
  if (!token) {
    throw new Error('No access token was returned from Universal Login');
  }
  return { token, redirectTo: appState && appState.redirectTo };
};

export const receiveUniversalLogin = async ({ store, router }) => {
  const callbackUrl = window.location.href;
  // 戻るボタンで認可コード付きの URL に戻らないよう、トークン交換より前にクエリを消す
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.hash}`);
  try {
    const { token, redirectTo } = await exchangeToken(callbackUrl);
    // Universal Login には「ログイン状態を保存する」が無く、資格はブラウザを閉じても残る
    await store.dispatch('setToken', { token, keep: true });
    router.replace(redirectTo || '/');
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
    store.dispatch('signOut');
    router.replace(UNIVERSAL_LOGIN_FAILED_ROUTE);
  }
};
